/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './threadgate.defs.js'
export * as $defs from './threadgate.defs.js'
